import { render, staticRenderFns } from "./FairsListPage.vue?vue&type=template&id=3f85bb1e&"
import script from "./FairsListPage.vue?vue&type=script&lang=js&"
export * from "./FairsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports